export default __webpack_public_path__ + "static/media/warren.9b7a107d.png";